import { createI18n } from 'vue-i18n';
import en from './locales/en';
import cs from './locales/cs';

export type Locale = 'en' | 'cs';
// `label` is the language's own native name (shown in the switcher).
export const LOCALES: { code: Locale; label: string }[] = [
  { code: 'en', label: 'English' },
  { code: 'cs', label: 'Čeština' },
];

const STORAGE_KEY = 'ps_locale';

function detectLocale(): Locale {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === 'en' || saved === 'cs') return saved;
  const nav = (navigator.language || '').toLowerCase();
  return nav.startsWith('cs') ? 'cs' : 'en';
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages: { en, cs },
});

export function setLocale(locale: Locale) {
  i18n.global.locale.value = locale;
  localStorage.setItem(STORAGE_KEY, locale);
  document.documentElement.lang = locale;
}

// Reflect the active locale on <html lang> from the first paint.
document.documentElement.lang = i18n.global.locale.value;
